import { render } from "./TabHeader.vue?vue&type=template&id=4193b8dc&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"

import "./TabHeader.vue?vue&type=style&index=0&id=4193b8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4193b8dc"]])

export default __exports__